import CryptoJS from "crypto-js";

const ENCRYPTION_KEY = "your-secret-key";

export const encryptData = (data: any) => {
    console.log("encryptData---encryptData---encryptData---encryptData", data)

    try {
        return CryptoJS.AES.encrypt(JSON.stringify(data), ENCRYPTION_KEY).toString();
    } catch (error) {
        console.error("Encryption Error:", error);
        return null;
    }
};

export const decryptData = (encryptedData: string | null) => {
    try {
        if (!encryptedData) return [];
        const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return Array.isArray(decryptedData) ? decryptedData : []; // Ensure it's always an array
    } catch (error) {
        console.error("Decryption Error:", error);
        return [];
    }
};
//